import { FilterType, ReportFilterItem } from '../../reportsTypes';
import * as z from 'zod';

export const shipSchema = z.object({
  name: z.string(),
  mmsi: z.string(),
  callSign: z.string(),
  imo: z.string(),
  type: z.string(),
});

export type Ship = z.infer<typeof shipSchema>;

/**
 * Creates a Zod schema for the filter field based on filter type and requirements.
 * @param filterType - The type of filter (normal, ship, shiplist, combined)
 * @param filterItems - Optional array of filter items containing required flag
 */
export function createDynamicFilterZodSchema(
  filterType: FilterType,
  filterItems?: ReportFilterItem[],
) {
  const schemaFields: Record<string, z.ZodTypeAny> = {};

  // Check if filter is required from filter items config
  const isFilterRequired = filterItems?.some((item) => item.required) ?? false;

  if (filterType === 'normal') {
    schemaFields['filter'] = z
      .string()
      .optional()
      .or(z.literal(''))
      .or(z.null());
  } else if (filterType === 'ship') {
    schemaFields['filter'] = z.array(shipSchema).optional().or(z.null());
  } else if (filterType === 'shiplist') {
    if (isFilterRequired) {
      schemaFields['filter'] = z
        .string()
        .min(1, 'Shiplist is required')
        .refine((val) => val !== 'no-filter', {
          message: 'Shiplist is required',
        });
    } else {
      schemaFields['filter'] = z
        .string()
        .optional()
        .or(z.literal(''))
        .or(z.null());
    }
  } else if (filterType === 'combined') {
    schemaFields['shiplist'] = z
      .string()
      .optional()
      .or(z.literal(''))
      .or(z.null());
    schemaFields['filter'] = z
      .string()
      .optional()
      .or(z.literal(''))
      .or(z.null());
  }

  const schema = z.object(schemaFields);

  return schema;
}
